// extracted by mini-css-extract-plugin
module.exports = {"progress":"Tasks_progress__1h54N","taskButton":"Tasks_taskButton__8pvBf","taskButtonText":"Tasks_taskButtonText__3_Prx"};